import axios from '@/core/axios';

import { CommercialGesture, CommercialGesturePayload, RefundableData } from './commercial-gestures.types';

export class CommercialGesturesService {
  getRefundable(orderId: number): Promise<RefundableData> {
    return axios.get<RefundableData>(`/orders/${orderId}/commercial-gestures/refundable`).then(resp => resp?.data);
  }

  getReasons(): Promise<string[]> {
    return axios.get<string[]>(`/commercial-gestures/reasons`).then(resp => resp?.data);
  }

  create(orderId: number, payload: CommercialGesturePayload): Promise<void> {
    return axios.post<void>(`/orders/${orderId}/commercial-gestures`, payload).then(() => undefined);
  }

  list(orderId: number): Promise<CommercialGesture[]> {
    return axios.get<CommercialGesture[]>(`/orders/${orderId}/commercial-gestures`).then(resp => resp?.data);
  }
}

export const commercialGesturesService = new CommercialGesturesService();
